/**
 * Nhãn (Tag) — đồng bộ với docs/Module/Business/Tag (all.md, list.md).
 * Field null bị BE lược bỏ nên hầu hết là optional.
 */
export interface ITag {
  id: string;
  fanpageId?: string; // ID page sở hữu (null = tag doanh nghiệp)
  fanpageName?: string; // Tên page — chỉ /business/tag/list mới trả
  businessId?: string; // ID doanh nghiệp (null = tag theo page)
  groupId?: string; // ID nhóm tag (nếu là tag nhóm DN)
  name: string;
  createdTime?: number; // Timestamp (giây)
  status?: number; // Xem TAG_STATUS
  order?: number;
  color: string;
  backgroundColor: string;
  code: string; // Mã nhãn
  typeBlock?: number | null; // 1: chặn tin nhắn, 2: chặn tất cả
  newTagId?: string[]; // ID nhãn được sao chép ra — chỉ /business/tag/list
  oldTagId?: string[]; // ID nhãn nguồn đã sao chép vào — chỉ /business/tag/list
  isSelected?: boolean; // Dùng cho UI chọn tag
  shortcut?: string; // Phím tắt gán nhãn
}

/** Trạng thái tag */
export const TAG_STATUS = {
  ACTIVE: 1,    // Hoạt động — hiển thị everywhere, cho phép gắn/gỡ
  INACTIVE: 2,  // Tạm ngưng — hiển thị nếu đã gắn, không cho gắn mới
  REMOVE: 3,    // Đã xóa — không load, không hiển thị
} as const;
export type TagStatusValue = typeof TAG_STATUS[keyof typeof TAG_STATUS];

export interface ITagGroup {
  id: string;
  name: string;
  businessId: string;
  pageIds: string[];
  createdAt?: number | null;
}

export interface ITagGroupView extends ITagGroup {
  editingName?: boolean;
  originalName?: string;
}

export interface ITagListParams {
  businessId?: string | number;
  ids?: string[];
  pageId?: string;
  pageIds?: string[];
  groupId?: string;
  status?: number;
  isGeneral?: number;
  notFindGroup?: number;
}

export interface ITagListData {
  result: ITag[];
}

export interface ITagListByBusinessParams {
  businessId: string | number;
  groupId?: string;
  getFirstGroup?: number;
  q?: string;
}

export interface ITagBusinessData {
  items: ITag[];
  groups: ITagGroup[];
}

export interface ITagAddParams {
  name: string;
  color: string;
  backgroundColor: string;
  businessId?: string | number;
  pageId?: string | number;
  shortcut?: string;
  groupId?: string;
  typeBlock?: number;
}

export interface ITagUpdateParams {
  id?: string;
  tagIds?: string[];
  removeMultiple?: number;
  removeTag?: number;
  businessId?: string | number;
  pageId?: string | string[];
  name?: string;
  color?: string;
  backgroundColor?: string;
  shortcut?: string;
  groupId?: string;
  status?: number;
  order?: number;
  typeBlock?: number;
  removeTypeBlock?: number;
}

export interface ITagPasteToParams {
  tags: ITag[] | string;
  copyTo: 1 | 2;
  pageIds?: string[];
  businessId?: string | number;
  groupIds?: string[];
  mode?: 1 | 2;
  isPageToGroup?: number;
}

export interface ITagPasteToData {
  result: ITag[];
}

export interface ITagGroupParams {
  businessId?: string | number;
  act: 'list' | 'add' | 'update' | 'remove';
  id?: string;
  name?: string;
  pageIds?: string[];
  removePageIds?: number;
}

/**
 * Tag đã nhóm theo tên (gộp các tag trùng tên ở nhiều page/group).
 * Dùng cho UI hiển thị chip/tag pill trong dialog chọn nhãn.
 */
export interface ITagGrouped {
  name: string;
  isSelected: boolean;
  tags: ITag[];
  backgroundColor: string;
  color: string;
}

/**
 * Kết quả trả về từ dialog chọn nhãn (Page vs DN).
 * - business: danh sách tag code thuộc DN
 * - [pageId]: danh sách tag code thuộc từng page
 * - selectedTags: toàn bộ tag code đã chọn (unique)
 * - tagNames: tên hiển thị đã chọn (unique)
 */
export interface ISelectTagResult {
  selectedTags: string[];
  tagNames: string[];
  business: string[];

  [pageId: string]: string[];
}
